export default class AjaxPopup
{
    closeNodeSelector = '.close';
    actionNodeSelector = '.action';

    constructor () {
        this.node = document.querySelector('#ajax-popup');
        this.contentNode = this.node.querySelector('.content');
        this.closeNode = this.node.querySelector(this.closeNodeSelector);
        this.state = false;

        this.init();
    }

    init() {
        const _this = this;
        this.closeNode.addEventListener('click', function (ev) {
            _this.hide();
        });
    }

    setContent(content) {
        this.contentNode.innerHTML = content;

        const _this = this;
        let closeNodes = this.contentNode.querySelectorAll(this.closeNodeSelector);
        for (let node of closeNodes) {
            node.addEventListener('click', function (ev) {
                _this.hide();
            });
        }

        let actionNodes = this.contentNode.querySelectorAll(this.actionNodeSelector);
        for (let node of actionNodes) {
            node.addEventListener('click', function (ev) {
                _this.setLoader();
                let url = node.getAttribute('data-url');
                if (!url) {
                    _this.setError();
                    return;
                }

                fetch(url)
                    .then(resp => resp.text())
                    .catch(err => {
                        _this.setError();
                    })
                    .then(answ => {
                        _this.setContent(answ);
                        document.location.reload();
                    });
            });
        }
    }

    setLoader() {
        // @todo нормальный вывод лоадера
        this.setContent(`<div class="loader"></div>`);
    }

    setError() {
        // @todo нормальный вывод ошибки
        this.setContent('error');
    }

    show() {
        document.querySelector('html').classList.add('no-scroll');

        this.node.classList.add('active');
        this.state = true;
    }

    hide() {
        document.querySelector('html').classList.remove('no-scroll')

        this.node.classList.remove('active');
        this.state = false;
    }
}